import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
    NgbDatepickerModule,
    NgbModalModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { FormElementsModule } from './form-elements/form-elements.module';
import { NavigationModule } from './navigation/navigation.module';
import { SearchPipe } from './pipes/search.pipe';
import { TableModule } from './table/table.module';
import { BarcodeScannerStrichComponent } from './barcode-scanner-strich/barcode-scanner-strich.component';
import { LocationPermissionModalComponent } from './location-permission-modal/location-permission-modal.component';
import { SafePipe } from './pipes/safe.pipe';

/**
 * SharedModule exists to make commonly used components, directives,
 * and pipes available for use in the templates of components throughout
 * the application.
 */
@NgModule({
    declarations: [
        SearchPipe,
        SafePipe,
        BarcodeScannerStrichComponent,
        LocationPermissionModalComponent,
    ],
    imports: [
        CommonModule,
        FormElementsModule,
        NgSelectModule,
        MatTableModule,
        MatButtonToggleModule,
        NgbTooltipModule,
        NgbDatepickerModule,
        NgbModalModule,
        NgbTypeaheadModule,
        NgbNavModule,
        FormsModule,
        NavigationModule,
        TableModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        MatSlideToggleModule,
    ],
    exports: [
        CommonModule,
        FormElementsModule,
        NgSelectModule,
        MatTableModule,
        MatButtonToggleModule,
        NgbTooltipModule,
        NgbDatepickerModule,
        NgbModalModule,
        NgbTypeaheadModule,
        NgbNavModule,
        FormsModule,
        NavigationModule,
        TableModule,
        ReactiveFormsModule,
        SearchPipe,
        SafePipe,
        FontAwesomeModule,
        BarcodeScannerStrichComponent,
        LocationPermissionModalComponent,
        MatSlideToggleModule,
    ],
})
export class SharedModule {}
